import { EditorCardProvider } from '@atlaskit/link-provider';

class BitbucketCardProvider extends EditorCardProvider {
  resolve(url: string) {
    return super.resolve(url, 'inline');
  }
}

export const smartCardProvider = Promise.resolve(new BitbucketCardProvider());
